import $ from "jquery";
// this file is needed to use jQuery's $.form.serializeObject() function used in billingform.jsx and upload.js

function jQSerializeObject() {
    return ($.fn.serializeObject = function() {
        let a;
        let o;
        o = {};
        a = this.serializeArray();
        $.each(a, function() {
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || "");
            } else {
                o[this.name] = this.value || "";
            }
        });
        return o;
    });
}
export default jQSerializeObject();
